<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8">
    <MediaImageLazyLoad
      :srcset="`/images/no-data.webp 320w`"
      src="/images/no-data.webp"
      placeholder-src="/images/no-data-tiny.webp"
      alt="no data"
      width="200px"
      height="auto"
      style="max-width: 230px;"
      :ratio="15/11"
      class="tw-mb-4"
    />
    <h3 class="tw-title-03 tw-font-medium tw-text-dark-gray">
      {{ title || $t('global.noData') }}
    </h3>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: '',
  },
})
</script>
